import Dropdown from '@/ui/dropdown/Dropdown';
import OutsideClickHandler from '@/shared/OutsideClickHandler';
import { DELAY_OPTIONS } from '@/utils/constants';

export const DelaySelector = ({ delay, delayRef, onDelaySelect, delayOptionsFiltered }) => {
	return (
		<div
			style={{
				maxWidth: '100%',
				position: 'relative',
				marginTop: 6,
			}}
		>
			<OutsideClickHandler onOutsideClick={() => delayRef.current.parentToggleModal(false)}>
				<div
					onClick={() => delayRef.current.parentToggleModal(true)}
					style={{
						cursor: 'pointer',
						position: 'relative',
					}}
				>
					Έτοιμη σε{' '}
					{` --> ${!delay ? DELAY_OPTIONS[0].label : delay} ${
						delay ? `λεπτ${delay === 1 ? 'ό' : 'ά'}` : ''
					}`}
				</div>
				<Dropdown ref={delayRef} onChange={onDelaySelect} options={delayOptionsFiltered} />
			</OutsideClickHandler>
		</div>
	);
};
